import React from 'react'
import { IonInput, IonItem, IonLabel } from '@ionic/react';


const Input = (props) => {
    return (
        <IonItem lines="none">
            <IonLabel className="input-label" position="stacked">{props.name}</IonLabel>
            <IonInput className='input-field' {...props} clearInput></IonInput>
        </IonItem>
    )
}

export default Input
